import React from 'react'
import img from '../../assest/signature.png'
const Signature = () => {
  return (
    <div>
    
     <div>
    <img src={img} className='w-25 m-auto' alt="" />
    </div></div>
  )
}

export default Signature